import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Form, Input, Button, Card, Typography } from 'antd';
import BackgroundChars from './BackgroundChars';

const { Title } = Typography;

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const loggedIn = await login(username, password);
    if (loggedIn) {
      navigate('/dashboard2');
    } else {
      // Handle login failure, maybe show a notification
    }
  };

  // If already authenticated, redirect to dashboard (in an effect, not during render)
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard2');
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
    <BackgroundChars />
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'relative', zIndex: 1 }}>
      <Card style={{ width: 300, textAlign: 'center' }}>
        <Title level={2}>Patren v2 Login</Title>
        <Form onFinish={handleSubmit}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input 
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password 
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
    </>
  );
};

export default Login;
